<template>
  <div class="new">
    <ComponentHeader v-bind:index="index" />

    <div id="image" class="image">
      <div>LAST INFORMATION</div>
      <div>最新资讯</div>
    </div>

    <section>
      <el-row class="block">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="content">
          <h3 class="title">{{ content.GG_BT }}</h3>
          <p class="title2">
            {{ content.GG_CJR }}&nbsp;&nbsp;{{ content.GG_CJSJ }}
          </p>
          <div class="new_part" v-html="content.GG_NR"></div>
        </el-col>
      </el-row>
      <el-row class="btn">
        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
          <button @click="back">返回</button>
        </el-col>
      </el-row>
    </section>
    <ComponentFooter />
  </div>
</template>


<script>
import "../ui/ui.js";
import { axios } from "../service/http";
import moment from "moment";
import ComponentFooter from "../components/Footer.vue";
import ComponentHeader from "../components/Header.vue";

export default {
  name: "Home",
  components: { ComponentFooter, ComponentHeader },
  data() {
    return {
      index: "3",
      news: [],
      content: "",
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    tabSelect(key, keyPath) {
      switch (key) {
        case "1":
          this.$router.push("/");
          break;
        case "2":
          this.$router.push("/CompanyIntr");
          break;
        case "3":
          this.$router.push("/news");
          break;
        case "4":
          this.$router.push("/business");
          break;
        case "5":
          this.$router.push("/connect");
          break;
        case "6":
          window.location.replace("http://tzfr.fengrunxidi.cn/#/dashboard");
          break;
        case "7":
          this.$router.push("/fwdw");
          break;
      }
    },
    getData() {
      axios
        .get("TZGG", { params: { id: this.$route.params.id } })
        .then((res) => {
          if (res.response.TZGG) {
            res.response.TZGG.GG_CJSJ = moment(
              res.response.TZGG.GG_CJSJ
            ).format("YYYY-MM-DD HH:mm:ss");
            this.content = res.response.TZGG;
          }
        });
    },
    setSize() {
      if (this.isLeave) return;
      var width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      let bannerHeight;
      if (width <= 767) {
        bannerHeight = (470 / 700) * width - 50 + "px";
      } else {
        bannerHeight = (470 / 850) * width - 50 + "px";
      }
      document.getElementById("image").style.height = bannerHeight;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.new {
  .el-row {
    margin: 0 !important;
  }
  .image {
    width: 100%;
    background: url("../assets/image/1-01-01.png") no-repeat;
    background-size: 100% 100%;
    height: 3.2rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    div {
      color: #d2f9e9;
      font-weight: 400;
      &:first-child {
        font-size: 0.18rem;
      }
      &:last-child {
        font-size: 0.15rem;
      }
    }
  }
  section {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .block {
      text-align: center;
      .content {
        margin: 0 auto;
        text-align: center;
        margin: 0.25rem 0 0 0;
        width: 100%;
        .title {
          // width: 95%;
          padding: 0 10px;
          font-size: 0.18rem;
        }
        .title2 {
          width: 95%;
          font-size: 0.09rem;
          color: gray;
          margin: 10px;
        }
        .new_part {
          font-size: 0.1rem;
          text-align: left;
          width: 80%;
          margin: 0 auto;
          img {
            width: 100% !important;
          }
        }
      }
    }
    .btn {
      font-size: 0.7rem;
      display: flex;
      justify-content: center;
      margin: 25px 0 22px 0;
      button {
        width: 84px;
        height: 33px;
        background: #e6fffb;
        border-radius: 30px;
        color: #000;
        outline: 0;
        border: 0;
      }
    }
  }
}
</style>